import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toSearchString } from 'utils/url';
import {
    FilterCategories,
    Accordion,
    AccordionItem,
    Spinner
} from 'components';
import * as gtm from '../../search-gtm';

const FilterCategoriesModal = ({
    filterCategories,
    handleCategoryChange,
    handleModalClick,
    pageType,
    isUpdating,
    queryParams
}) => {
    const { categoryTree } = filterCategories;
    const showAllQuery =
        queryParams && queryParams.q
            ? { q: queryParams.q, categoryId: categoryTree.id }
            : {};
    return (
        <Fragment>
            <div className="search-modal__header fixed-top d-flex justify-content-center align-items-center font-weight-bold">
                Kategorier
                <Link
                    to={{
                        pathname: categoryTree.url,
                        search: toSearchString(showAllQuery)
                    }}
                    onClick={() => {
                        gtm.trackAction('Category menu', 'View all categories');
                        handleModalClick('');
                    }}
                    className="clear-all--modal font-weight-bold text-danger">
                    <div className="category-link-title">Visa alla</div>
                </Link>
            </div>
            {isUpdating && <Spinner className="filters--updating" />}
            <Accordion>
                <AccordionItem
                    title={'Alla Kategorier'}
                    defaultOpen={true}
                    collapsable={false}
                    hideTitle={true}
                    render={() => (
                        <FilterCategories
                            filterCategories={filterCategories}
                            handleCategoryChange={handleCategoryChange}
                            pageType={pageType}
                            queryParams={queryParams}
                        />
                    )}
                />
            </Accordion>
        </Fragment>
    );
};

FilterCategoriesModal.propTypes = {
    filterCategories: PropTypes.shape({
        categoryTree: PropTypes.object,
        parameter: PropTypes.string,
        type: PropTypes.string
    }).isRequired,
    handleCategoryChange: PropTypes.func,
    handleModalClick: PropTypes.func,
    pageType: PropTypes.string.isRequired,
    isUpdating: PropTypes.bool,
    queryParams: PropTypes.object.isRequired
};

export default FilterCategoriesModal;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/filters/categories/filter-categories-modal.jsx